module.exports = __webpack_public_path__ + "static/media/fi-rr-notebook.31822eee.svg";